import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ContractCard from "./ContractCard";
import EmptyState from "./EmptyState";
import heartLoading from "../../../assests/heartLoading.gif";
import ReportCard from "./ReportCard";
import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
} from "../../../redux/domainAddToCart/domainAddToCart.type";

const ContractList = ({
  activeTab,
  filteredContracts,
  mySubscriptions,
  myContracts,
  reports,
  handleShareReport,
  handleViewReport,
  subscribedTables,
  handleSubscribe,
  handleReportSubscribe,
  handleViewProfile,
  handleViewContract,
  handleViewProduct,
  handleViewAssetDetails,
  handleViewResult,
  handleViewLineage,
  handleLineageTransformation,
  // Pagination props
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
  maxHits,
  // Loading states
  loading,
  searchLoading,
  filterLoading,
  setAssetName,
  selectedAssetList,
  setSelectedAssetList,
  selectedTab,
}) => {
  const cartItems = useSelector((state) => state.domainAddToCart);
  const dispatch = useDispatch();
  // Loading component for search operations

  const SearchLoadingSpinner = () => (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <img src={heartLoading} alt="Loading..." className="h-32 w-32" />
        <div className="space-y-2">
          <p className="text-gray-700 text-xl font-semibold">Searching...</p>
          <p className="text-gray-500 text-base">
            Fetching data based on your search
          </p>
        </div>
      </div>
    </div>
  );

  // Loading component for filter operations
  const FilterLoadingSpinner = () => (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <img src={heartLoading} alt="Loading..." className="h-32 w-32" />
        <div className="space-y-2">
          <p className="text-gray-700 text-xl font-semibold">
            Applying filters...
          </p>
          <p className="text-gray-500 text-base">
            Updating results based on your selection
          </p>
        </div>
      </div>
    </div>
  );

  // Loading component for general operations (tab switch, initial load)
  const GeneralLoadingSpinner = () => (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <img src={heartLoading} alt="Loading..." className="h-32 w-32" />
        <div className="space-y-2">
          <p className="text-gray-700 text-xl font-semibold">Loading...</p>
          <p className="text-gray-500 text-base">
            Hang tight! The resources are loading...
          </p>
        </div>
      </div>
    </div>
  );

  // Early return for loading states - these take absolute priority
  if (searchLoading) {
    return <SearchLoadingSpinner />;
  }

  if (filterLoading) {
    return <FilterLoadingSpinner />;
  }

  if (loading) {
    return <GeneralLoadingSpinner />;
  }

  // Generate page numbers array
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 10; // Show max 10 page numbers

    if (totalPages <= maxVisiblePages) {
      // If total pages <= 10, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // If total pages > 10, show smart pagination
      if (currentPage <= 5) {
        // Show first 10 pages
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
      } else if (currentPage >= totalPages - 4) {
        // Show last 10 pages
        for (let i = totalPages - 9; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Show 5 pages before and 4 pages after current page
        for (let i = currentPage - 5; i <= currentPage + 4; i++) {
          pages.push(i);
        }
      }
    }

    return pages;
  };
  const pageNumbers = getPageNumbers();

  const renderPagination = () => {
    if (totalPages <= 1) {
      return null;
    }

    const pageNumbers = getPageNumbers();

    return (
      <div className="pagination-container">
        <div className="pagination-info">
          Showing {(currentPage - 1) * pageSize + 1}-
          {Math.min(currentPage * pageSize, totalCount)} of {totalCount} items
        </div>

        <div className="pagination-controls">
          {/* Previous button */}
          <button
            className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {/* Page numbers */}
          <div className="page-numbers">
            {pageNumbers.map((pageNum) => (
              <button
                key={pageNum}
                className={`page-number ${
                  currentPage === pageNum ? "active" : ""
                }`}
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </button>
            ))}
          </div>

          {/* Next button */}
          <button
            className={`pagination-btn ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    );
  };
  const PaginationRender = () => {
    if (totalPages <= 1) {
      return null;
    }

    const pageNumbers = getPageNumbers();

    return (
      <div className="pagination-controlsss">
        <div className="pagination-controls">
          {/* Previous button */}
          <button
            className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {/* Page numbers */}
          <div className="page-numbers">
            {pageNumbers.map((pageNum) => (
              <button
                key={pageNum}
                className={`page-number ${
                  currentPage === pageNum ? "active" : ""
                }`}
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </button>
            ))}
          </div>

          {/* Next button */}
          <button
            className={`pagination-btn ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    );
  };
  const handleSelectall = (e) => {
    if (e.target.checked) {
      // Add myContracts to Redux cart without duplicates
      const existingIds = new Set(cartItems.map((item) => item.id));

      const newItems =
        myContracts
          ?.filter((contract) => !existingIds.has(contract.id))
          .map(({ id, name, productName }) => ({
            id,
            name,
            productName,
          })) || [];

      if (newItems.length > 0) {
        dispatch({
          type: ADD_TO_CART,
          payload: newItems,
        });
      }
    } else {
      // Remove only the items from myContracts
      const myContractIds = myContracts?.map((c) => c.id) || [];

      dispatch({
        type: REMOVE_FROM_CART,
        payload: myContractIds,
      });
    }
  };

  // console.log("selectedData", selectedAssetList)

  const selectedAll =
    myContracts?.length > 0 &&
    myContracts.every((contract) =>
      cartItems.some((asset) => asset.id === contract.id)
    );

  return (
    <div className="contract-list">
      {activeTab === "all" &&
        (filteredContracts && filteredContracts.length > 0 ? (
          <>
            {/* Total Results Count Display */}
            <div className="flex justify-between ">
              <div className="flex items-center gap-4">
                {selectedTab === "assets" && (
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="select-all"
                      className="h-4 rounded border-gray-300 text-[#bb1ccc] focus:ring-[#bb1ccc]"
                      onChange={handleSelectall}
                      checked={selectedAll}
                    />
                    <label for="select-all" className="text-md text-gray-800">
                      Select All on Page
                    </label>
                  </div>
                )}

                <div className="text-md">
                  Showing {(currentPage - 1) * pageSize + 1}-
                  {Math.min(currentPage * pageSize, totalCount)} of {totalCount}{" "}
                  items
                </div>
              </div>
              <div>
                <div>{PaginationRender()}</div>
              </div>
            </div>

            {filteredContracts.map((contract) => (
              <ContractCard
                key={contract.id}
                contract={contract}
                isSubscribed={subscribedTables.includes(contract.id)}
                onSubscribe={() => handleSubscribe(contract)}
                onReportSubscribe={() => handleReportSubscribe(contract)}
                onViewProfile={() => handleViewProfile(contract)}
                onViewContract={() => handleViewContract(contract)}
                onViewProduct={() => handleViewProduct(contract)}
                onViewAssetDetails={() => handleViewAssetDetails(contract)}
                onViewResult={() => handleViewResult(contract)}
                setAssetName={setAssetName}
                onViewLineage={() => handleViewLineage(contract)}
                onLineageTransformation={() =>
                  handleLineageTransformation(contract)
                }
                activeTab={activeTab}
                selectedAssetList={cartItems}
                setSelectedAssetList={null}
                maxHits={maxHits}
                showCheckbox={true}
                selectedTab={selectedTab}
              />
            ))}

            {/* Pagination */}
            {renderPagination()}
          </>
        ) : (
          <EmptyState message="No data contracts available" />
        ))}

      {activeTab === "mySubscriptions" &&
        (mySubscriptions && mySubscriptions.length > 0 ? (
          <>
            {/* Total Results Count Display */}
            <div className="flex justify-end mb-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-2">
                <span className="text-blue-800 font-medium text-sm">
                  {totalCount} results found
                </span>
              </div>
            </div>

            {mySubscriptions.map((contract) => (
              <ContractCard
                key={contract.id}
                contract={contract}
                isSubscribed={subscribedTables.includes(contract.id)}
                onSubscribe={() => handleSubscribe(contract)}
                onViewProfile={() => handleViewProfile(contract)}
                onViewContract={() => handleViewContract(contract)}
                onViewProduct={() => handleViewProduct(contract)}
                onViewAssetDetails={() => handleViewAssetDetails(contract)}
                onViewResult={() => handleViewResult(contract)}
                onViewLineage={() => handleViewLineage(contract)}
                activeTab={activeTab}
                maxHits={maxHits}
              />
            ))}

            {/* Pagination */}
            {renderPagination()}
          </>
        ) : (
          <EmptyState message="No subscriptions found" />
        ))}

      {activeTab === "myContracts" &&
        (myContracts && myContracts.length > 0 ? (
          <>
            {/* Total Results Count Display */}
            <div className="flex justify-end mb-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-2">
                <span className="text-blue-800 font-medium text-sm">
                  {totalCount} results found
                </span>
              </div>
            </div>

            {myContracts.map((contract) => (
              <ContractCard
                key={contract.id}
                contract={contract}
                isSubscribed={subscribedTables.includes(contract.id)}
                onSubscribe={() => handleSubscribe(contract)}
                onViewProfile={() => handleViewProfile(contract)}
                onViewContract={() => handleViewContract(contract)}
                onViewProduct={() => handleViewProduct(contract)}
                onViewAssetDetails={() => handleViewAssetDetails(contract)}
                onViewResult={() => handleViewResult(contract)}
                onViewLineage={() => handleViewLineage(contract)}
                activeTab={activeTab}
                maxHits={maxHits}
              />
            ))}

            {/* Pagination */}
            {renderPagination()}
          </>
        ) : (
          <EmptyState message="No contracts found" />
        ))}
      {activeTab === "reports" &&
        (reports && reports.length > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {reports.map((report) => (
                <ReportCard
                  key={report.data_asset_id}
                  report={report}
                  onShareReport={handleShareReport}
                  onViewReport={handleViewReport}
                />
              ))}
            </div>
          </>
        ) : (
          <EmptyState message="No contracts found" />
        ))}
    </div>
  );
};

export default ContractList;
